import { render, staticRenderFns } from "./BillsList.vue?vue&type=template&id=33776e59&scoped=true"
import script from "./BillsList.ts?vue&type=script&lang=ts&external"
export * from "./BillsList.ts?vue&type=script&lang=ts&external"
import style0 from "./BillsList.vue?vue&type=style&index=0&id=33776e59&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33776e59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33776e59')) {
      api.createRecord('33776e59', component.options)
    } else {
      api.reload('33776e59', component.options)
    }
    module.hot.accept("./BillsList.vue?vue&type=template&id=33776e59&scoped=true", function () {
      api.rerender('33776e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/components/list/BillsList/BillsList.vue"
export default component.exports